import type { DataPointHistory } from "../../apiClient/generated";
import { AlignedDataDisplay } from "../../ui/GenericFields";
import { formatDateTime } from "../../utils/dates";

interface DataPointHistoryDisplayProps {
    history: DataPointHistory[];
}

export const DataPointHistoryDisplay = (
    props: DataPointHistoryDisplayProps,
) => {
    const { history } = props;

    const viewData = [];

    (history || []).forEach((historyItem) => {
        viewData.push({
            label: "Version:",
            value: historyItem.version,
        });
        viewData.push({
            label: "Modified:",
            value: historyItem.changedAt
                ? formatDateTime(historyItem.changedAt)
                : "N/A",
        });
        viewData.push({
            label: "Detection Limit:",
            value: <>{(historyItem.detectionLimit / 1000).toFixed(2)} kg/h</>,
        });

        if (historyItem.detectedRate && historyItem.detectedRate > 0) {
            viewData.push({
                label: "Detected rate:",
                value: <>{(historyItem.detectedRate / 1000).toFixed(2)} kg/h</>,
            });
        }

        if (
            historyItem.detectedRateUncertainty &&
            historyItem.detectedRateUncertainty > 0
        ) {
            viewData.push({
                label: "Detected rate uncertainty:",
                value: (
                    <>
                        ±{" "}
                        {(historyItem.detectedRateUncertainty / 1000).toFixed(
                            2,
                        )}{" "}
                        kg/h
                    </>
                ),
            });
        }

        if (historyItem.concentration) {
            viewData.push({
                label: "Concentration:",
                value: <>{historyItem.concentration.toFixed(2)} ppm*m</>,
            });
        }

        if (historyItem.concentrationUncertainty) {
            viewData.push({
                label: "Concentration uncertainty:",
                value: (
                    <>
                        ± {historyItem.concentrationUncertainty?.toFixed(2)}{" "}
                        ppm*m
                    </>
                ),
            });
        }
    });

    return <AlignedDataDisplay data={viewData} />;
};
